<template>
  <div id="lgpr">
    <!-- <Create
      v-if="lgpr.status === 'draft'"
      :lgpr.sync="lgpr"
    />
    <Status
      v-else
      :lgpr="lgpr"
    /> -->
    <Create
      v-if="false"
      :lgpr.sync="lgpr"
    />
    <Status
      :lgpr="lgpr"
    />
  </div>
</template>

<script>
import api from '@/api';
import Create from './Create.vue';
import Status from './Status.vue';

export default {
  components: {
    Create,
    Status,
  },

  data() {
    return {
      lgpr: {},
    };
  },

  created() {
    this.getCurrentLGPR();
  },

  methods: {
    async getCurrentLGPR() {
      try {
        const response = await api.getCurrentLGPR();
        this.lgpr = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#lgpr {
  .stepContent {
    padding: 10px;
  }
}
</style>
